import Auth from '../../utils/Auth'

module.exports = {
  path: 'core',
  onEnter: Auth.redirectToLogin,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], require => {
      cb(null, [
        require('./routes/charts'),
        require('./routes/dashboard'),
        require('./routes/ecommerce'),
        require('./routes/forms'),
        require('./routes/pageLayouts'),
        require('./routes/pages'),
        require('./routes/tables'),
        require('./routes/ui')
      ])
    })
  },
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require('./components/MainApp'))
    })
  }
}



// WEBPACK FOOTER //
// ./routes/core/index.js